module.exports = __webpack_public_path__ + "static/media/t2.1f1600c4.png";